import { Component } from '@angular/core';
import { LandingPageService } from '../landing-page/landing-page.service';
import { Router } from '@angular/router';
import { SharingDataService } from 'src/sharing-data.service';

@Component({
  selector: 'app-women-oversized-printed',
  templateUrl: './women-oversized-printed.component.html',
  styleUrls: ['./women-oversized-printed.component.css']
})
export class WomenOversizedPrintedComponent {

   ngAfterViewInit() {
    // This executes right after the HTML hits the screen
    setTimeout(() => {
      // Fake a window resize event to force the browser to snap the header and banner together
      window.dispatchEvent(new Event('resize'));
    }, 50); // A 50ms delay is invisible to the user but enough for the browser
  }


  ngOnInit(): void {
    // Your initialization logic here
    console.log('Component initialized!');
    this.viewAllFourProducts();
    this. viewProductComponent=false;
    this.Cart=0;
     this.viewAllFemaleProducts();
  }
  constructor(private landingPageService : LandingPageService,private router: Router,private sharingData: SharingDataService){}
  Cart=0;
  products:any;
  viewProductComponent=false;
  femalePrinted: any[] = [];
  femaleProducts:any;

  tshirts = [
    { src: '../../assets/img/tshirt1.jpg', name: 'Black T Rs699' , label: 'Add to Cart'},
    { src: '../../assets/img/tshirt1.jpg', name: 'Red T Rs699' , label: 'Add to Cart' },
    { src: '../../assets/img/tshirt1.jpg', name: 'White T Rs699' , label: 'Add to Cart' },
    { src: '../../assets/img/tshirt1.jpg', name: 'Blue T Rs699' , label: 'Add to Cart' }
   
  ];

  addToCart(tshirt:any){
    this.Cart=this.Cart+1;
    console.log("Cart=",this.Cart);
    console.log("tshirt=",tshirt.name);
   }
   viewAllFourProducts(){
    this.landingPageService.ViewAllProductsFunctions().subscribe({
      next:(response) => {
        console.log('All products are', response);
        this.products=response;
        console.log('All products are', this.products);
      },
      error: (err) => {
        console.error('Error:', err);
      }
    });
  }
  
  viewProduct(product:Object) {
    console.log(" menOversizedPlain button clicked");
    this.viewProductComponent = true;
    this.router.navigate(['/viewProducts']);
    this.sharingData.updateValue(product);
    console.log('clicked view product: ',product);
  }

  viewAllFemaleProducts(){
  //     const targetImages=[
  //   '../../assets/img/IMG_pista_eye_woman_2.jpg',
  //   '../../assets/img/IMG_woman_beige_body_3.jpg',
  //   '../../assets/img/IMG_woman_beige_plain_2.jpg',
  //   '../../assets/img/IMG_woman_pista_plain_2.jpg'
  // ]
  this.sharingData.GetAllFemaleProducts().subscribe({
    next:(response) => {
     
      this.femaleProducts=response;
        console.log('all producrs',response)
           this.femalePrinted = [];
      for(let i=0;i<this.femaleProducts.length;i++){
     
        if ((this.femaleProducts[i].category)== 'Printed'){
        console.log('Category is Printed');
          this.femalePrinted.push(this.femaleProducts[i]);
        }
      }
      console.log('All male printed are', this.femalePrinted);
    },
    error: (err) => {
      console.error('Error:', err);
    }
  });
}
  
}
